import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AdminUserDto, UsersService } from './core/services/users.service';
import { Subject } from 'rxjs';
import { AuthService } from './core/auth/auth.service';
import { ApiResponse } from './core/models/api-response.model';
import { MenuService, NavigationMenuItem } from './core/services/menu.service';
import { TokenDecodeService } from './core/services/token-decode.service';
import { PopupService } from './shared/services/popup.service';
import { IdleTimeoutService } from './core/services/idle-timeout.service';
import { APP_MESSAGES } from './shared/constants/app-messages.constants';

const APP_TEXT = APP_MESSAGES.APP;

// type MenuChild = {
//   label: string;
//   route: string;
//   lightIcon?: string;
//   darkIcon?: string;
// };

// type MenuItem = {
//   id: string;
//   label: string;
//   lightIcon: string;
//   darkIcon: string;
//   route?: string;
//   children?: MenuChild[];
// };

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {

  user = false;

  pageTitle:any = APP_TEXT.DEFAULT_PAGE_TITLE;

  collapsed = false;
  hoverExpanded = false;

  openGroups = new Set<string>();

  currentUrl = '';

  profileOpen = false;
  isNotificationsOpen = false;

  @ViewChild('notifWrap', { static: false }) notifWrap?: ElementRef;

  currentProfile: AdminUserDto | null =
    null;

  private profileLoaded = false;

  private readonly destroy$ = new Subject<void>();

  // menu: MenuItem[] = [
  //   {
  //     id: 'dash',
  //     label: 'Dashboard',
  //     lightIcon: 'assets/img/dashboard-dim.svg',
  //     darkIcon: 'assets/img/dashboard.svg',
  //     route: '/dashboard'
  //   },
  //   {
  //     id: 'jobPosition',
  //     label: 'Job Positions',
  //     lightIcon: 'assets/img/job-position-dim.svg',
  //     darkIcon: 'assets/img/job-position.svg',
  //     route: '/jobPosition'
  //   },

  //   {
  //     id: 'candidates',
  //     label: 'Candidates',
  //     lightIcon: 'assets/img/candidate-dim.svg',
  //     darkIcon: 'assets/img/candidate.svg',
  //     route: '/candidates'
  //   },
  //   {
  //     id: 'recruiters',
  //     label: 'Recruiters',
  //     lightIcon: 'assets/img/recuiter-dim.svg',
  //     darkIcon: 'assets/img/recuiter.svg',
  //     route: '/recruiters'
  //   },
  //   {
  //     id: 'userManagement',
  //     label: 'User Management',
  //     lightIcon: 'assets/img/user-management-dim.svg',
  //     darkIcon: 'assets/img/user-management-light.svg',
  //     children: [
  //       {
  //         label: 'Users',
  //         route: '/user-management',
  //         lightIcon: 'assets/img/candidate-dim.svg',
  //         darkIcon: 'assets/img/candidate.svg'
  //       },
  //       {
  //         label: 'Roles',
  //         route: '/roles',
  //         lightIcon: 'assets/img/role-dim.svg',
  //         darkIcon: 'assets/img/role-light.svg'
  //       },
  //       {
  //         label: 'Groups',
  //         route: '/groups',
  //         lightIcon: 'assets/img/group-dim.svg',
  //         darkIcon: 'assets/img/group-light.svg'
  //       },
  //       // {
  //       //   label: 'Permissions',
  //       //   route: '/permissions',
  //       //   lightIcon: 'assets/img/permission-dim.svg',
  //       //   darkIcon: 'assets/img/permission-light.svg'
  //       // },
  //       // {
  //       //   label: 'Group Permissions',
  //       //   route: '/group-permissions',
  //       //   lightIcon: 'assets/img/grouppermission-dim.svg',
  //       //   darkIcon: 'assets/img/grouppermission-light.svg'
  //       // },
  //       // {
  //       //   label: 'Role Permissions',
  //       //   route: '/role-permissions',
  //       //   lightIcon: 'assets/img/role-permission-dim.svg',
  //       //   darkIcon: 'assets/img/role-permission-light.svg'
  //       // },
  //       {
  //         label: 'Menu',
  //         route: '/menu',
  //         lightIcon: 'assets/img/menu-dim.svg',
  //         darkIcon: 'assets/img/menu-light.svg'
  //       }
  //     ]
  //   },
  //   // {
  //   //   id: 'rcChat',
  //   //   label: 'Recruiter Chat',
  //   //   lightIcon: 'assets/img/rc-chat-dim.svg',
  //   //   darkIcon: 'assets/img/rc-chat.svg',
  //   //   route: '/recruiter-chat'
  //   // },
  //   // {
  //   //   id: 'reports',
  //   //   label: 'Reports',
  //   //   lightIcon: 'assets/img/reports-dim.svg',
  //   //   darkIcon: 'assets/img/reports-light.svg',
  //   //   route: '/reports'
  //   // },
  //   {
  //     id: 'interviews',
  //     label: 'Live Interviews',
  //     lightIcon: 'assets/img/technical-dim.svg',
  //     darkIcon: 'assets/img/technical-light.svg',
  //     children: [
  //       {
  //         label: 'Pre-Screening',
  //         route: '/interviews/pre-screening',
  //         lightIcon: 'assets/img/recruitment-dim.svg',
  //         darkIcon: 'assets/img/recruitment-light.svg'
  //       },
  //       {
  //         label: 'Indepth',
  //         route: '/interviews/technical',
  //         lightIcon: 'assets/img/technical-dim.svg',
  //         darkIcon: 'assets/img/technical-light.svg'
  //       },
  //     ]
  //   },
  // ];

  menu: NavigationMenuItem[] = [];
  isLoginRoute = false;
  private readonly noShellRoutes = [
    '/login',
    '/first-login-password'
  ];

  constructor(
    private router: Router,
    private translate: TranslateService,
    private authService: AuthService,
    private usersService: UsersService,
    private menuService: MenuService,
    private tokenDecodeService: TokenDecodeService,
    private popup: PopupService,
    private idleTimeout: IdleTimeoutService
  ) {
    this.currentUrl = this.router.url;

    const storedLang =
      sessionStorage.getItem(
        'i18n.lang'
      );

    const lang = storedLang || 'en';

    this.translate.setDefaultLang('en');
    void this.translate.use(lang);

    this.syncShellByUrl(
      this.currentUrl
    );

    this.router.events
      .pipe(
        filter(
          event =>
            event instanceof NavigationEnd
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(event => {
        const navigationEvent =
          event as NavigationEnd;

        this.currentUrl =
          navigationEvent.urlAfterRedirects;

        this.syncShellByUrl(
          this.currentUrl
        );

        if (this.user) {
          this.autoOpenActiveGroup();
          this.updateTitleFromMenu();
          this.loadCurrentProfileIfRequired();
        }

        const deniedUrl =
          sessionStorage.getItem(
            'accessDeniedUrl'
          );

        if (deniedUrl) {

          sessionStorage.removeItem(
            'accessDeniedUrl'
          );

          const pageName =
            this.getPageNameFromUrl(
              deniedUrl
            );

          setTimeout(() => {

            void this.popup.warning(
              APP_TEXT.ACCESS_DENIED.message(pageName),
              APP_TEXT.ACCESS_DENIED.title
            );

          }, 100);
        }
      });

    this.autoOpenActiveGroup();
    this.updateTitleFromMenu();
  }

  private getPageNameFromUrl(
    url: string
  ): string {

    const cleanUrl =
      String(url || '')
        .split('?')[0]
        .split('#')[0]
        .replace(/^\/+|\/+$/g, '');

    if (!cleanUrl) {
      return APP_TEXT.FALLBACK_PAGE_LABEL;
    }

    return cleanUrl
      .split('/')
      .map(part =>
        part
          .replace(
            /([a-z])([A-Z])/g,
            '$1 $2'
          )
          .replace(
            /[-_]+/g,
            ' '
          )
          .replace(
            /\b\w/g,
            character =>
              character.toUpperCase()
          )
      )
      .join(' / ');
  }

  private loadCurrentProfileIfRequired():
    void {

    if (
      this.profileLoaded ||
      !this.authService.isAuthenticated() ||
      this.authService
        .isAnyPasswordActionRequired()
    ) {
      return;
    }

    this.profileLoaded = true;

    this.usersService
      .getMyProfile()
      .subscribe({
        next: response => {
          if (
            !response.success ||
            !response.data
          ) {
            this.profileLoaded = false;
          }
        },

        error: (error: unknown) => {
          console.error(
            'Failed to load current profile:',
            error
          );

          this.profileLoaded = false;
        }
      });
  }

  private syncShellByUrl(url: string): void {
    const urlTree = this.router.parseUrl(
      url || '/'
    );

    const primarySegments =
      urlTree.root.children['primary']
        ?.segments || [];

    const routePath =
      '/' +
      primarySegments
        .map(segment => segment.path)
        .join('/');

    const normalizedPath =
      routePath.length > 1
        ? routePath.replace(/\/+$/, '')
        : routePath;

    const hideShell =
      normalizedPath === '/' ||
      this.noShellRoutes.some(
        route =>
          normalizedPath === route ||
          normalizedPath.startsWith(
            `${route}/`
          )
      );

    this.isLoginRoute = hideShell;
    this.user = !hideShell;

    if (hideShell) {
      this.profileOpen = false;
      this.isNotificationsOpen = false;
      this.openGroups.clear();
    }
  }

  get sidebarExpanded(): boolean {
    return !this.collapsed || this.hoverExpanded;
  }

  toggleSidebar(): void {
    this.collapsed = !this.collapsed;

    if (this.collapsed) {
      this.openGroups.clear();
      this.hoverExpanded = false;
    } else {
      this.autoOpenActiveGroup();
    }
  }

  onSidebarEnter(): void {
    if (this.collapsed) {
      this.hoverExpanded = true;
      this.autoOpenActiveGroup();
    }
  }

  onSidebarLeave(): void {
    this.hoverExpanded = false;

    if (this.collapsed) {
      this.openGroups.clear();
    }
  }

  toggleGroup(
    id: string,
    preserveAncestors = false,
    event?: MouseEvent
  ): void {
    event?.preventDefault();
    event?.stopPropagation();

    if (this.collapsed && !this.hoverExpanded) {
      this.hoverExpanded = true;
    }

    if (this.openGroups.has(id)) {
      this.closeGroupAndDescendants(id);
      return;
    }

    /*
     * Opening a top-level group closes the previous tree.
     * Opening a nested group keeps its parent groups open.
     */
    if (!preserveAncestors) {
      this.openGroups.clear();
    }

    this.openGroups.add(id);
  }

  onSimpleMenuClick(): void {
    this.openGroups.clear();

    if (this.collapsed) {
      this.hoverExpanded = false;
    }
  }

  onNestedMenuLinkClick(): void {
    /*
     * Do not clear openGroups here. The router event will call
     * autoOpenActiveGroup() and restore every active ancestor.
     */
    if (this.collapsed) {
      this.hoverExpanded = false;
    }
  }

  onNestedParentClick(
    item: NavigationMenuItem,
    event: MouseEvent
  ): void {
    event.preventDefault();
    event.stopPropagation();

    const wasOpen =
      this.isGroupOpen(item.id);

    /*
     * Nested parents behave like top-level parents:
     * clicking anywhere on the row opens or closes the children.
     */
    this.toggleGroup(
      item.id,
      true
    );

    /*
     * Preserve the nested parent's own page. Navigate only while
     * opening it. When closing, remaining on the current route
     * prevents autoOpenActiveGroup() from reopening it immediately.
     */
    if (
      !wasOpen &&
      item.route &&
      !this.isRouteActive(item.route)
    ) {
      void this.router.navigateByUrl(
        item.route
      );
    }
  }

  private closeGroupAndDescendants(id: string): void {
    const group = this.findMenuItemById(
      this.menu,
      id
    );

    if (!group) {
      this.openGroups.delete(id);
      return;
    }

    this.removeOpenGroupTree(group);
  }

  private removeOpenGroupTree(
    item: NavigationMenuItem
  ): void {
    this.openGroups.delete(item.id);

    item.children?.forEach(child =>
      this.removeOpenGroupTree(child)
    );
  }

  private findMenuItemById(
    items: NavigationMenuItem[],
    id: string
  ): NavigationMenuItem | null {
    for (const item of items) {
      if (item.id === id) {
        return item;
      }

      if (item.children?.length) {
        const match = this.findMenuItemById(
          item.children,
          id
        );

        if (match) {
          return match;
        }
      }
    }

    return null;
  }

  isGroupOpen(id: string): boolean {
    return this.openGroups.has(id);
  }

  isRouteActive(
    route?: string | null
  ): boolean {
    if (!route) {
      return false;
    }

    return (
      this.currentUrl === route ||
      this.currentUrl.startsWith(
        `${route}/`
      )
    );
  }

  // isItemActive(item: MenuItem): boolean {
  //   if (item.route) {
  //     return this.isRouteActive(item.route);
  //   }

  //   if (item.children?.length) {
  //     return item.children.some((child) => this.isRouteActive(child.route));
  //   }

  //   return false;
  // }

  private autoOpenActiveGroup(): void {
    const activePath =
      this.findActiveMenuPath(
        this.menu
      );

    if (!activePath.length) {
      return;
    }

    this.openGroups.clear();

    /*
     * Open every group in the active route path.
     * Example: User Management -> Menu -> Test Menu
     * opens both User Management and Menu.
     */
    activePath.forEach(item => {
      if (item.children?.length) {
        this.openGroups.add(item.id);
      }
    });
  }

  private findActiveMenuPath(
    items: NavigationMenuItem[]
  ): NavigationMenuItem[] {
    for (const item of items) {
      /*
       * Search children first so a nested route such as
       * /menu/test is preferred over its parent /menu.
       */
      if (item.children?.length) {
        const childPath =
          this.findActiveMenuPath(
            item.children
          );

        if (childPath.length) {
          return [item, ...childPath];
        }
      }

      if (
        item.route &&
        this.isRouteActive(item.route)
      ) {
        return [item];
      }
    }

    return [];
  }
  isItemActive(
    item: NavigationMenuItem
  ): boolean {
    if (
      item.route &&
      this.isRouteActive(item.route)
    ) {
      return true;
    }

    return Boolean(
      item.children?.some(child =>
        this.isItemActive(child)
      )
    );
  }

  getItemIcon(
    item: NavigationMenuItem
  ): string {
    return this.isItemActive(item)
      ? item.darkIcon
      : item.lightIcon;
  }

  getChildIcon(
    child: NavigationMenuItem
  ): string {
    return this.isItemActive(child)
      ? child.darkIcon
      : child.lightIcon;
  }

  // getItemIcon(item: MenuItem): string {
  //   return this.isItemActive(item) ? item.darkIcon : item.lightIcon;
  // }

  // getChildIcon(child: MenuChild): string {
  //   if (this.isRouteActive(child.route)) {
  //     return child.darkIcon || child.lightIcon || '';
  //   }

  //   return child.lightIcon || child.darkIcon || '';
  // }
  private updateTitleFromMenu(): void {
    const activeItem =
      this.findActiveMenuItem(
        this.menu
      );

    this.pageTitle =
      activeItem?.label ||
      APP_TEXT.DEFAULT_PAGE_TITLE;
  }

  private findActiveMenuItem(
    items: NavigationMenuItem[]
  ): NavigationMenuItem | null {

    for (const item of items) {
      if (item.children?.length) {
        const activeChild =
          this.findActiveMenuItem(
            item.children
          );

        if (activeChild) {
          return activeChild;
        }
      }

      if (
        item.route &&
        this.isRouteActive(item.route)
      ) {
        return item;
      }
    }

    return null;
  }
  toggleProfile(): void {
    this.profileOpen = !this.profileOpen;
  }

  closeProfile(): void {
    this.profileOpen = false;
  }

  Logout(): void {
    this.authService.logout(false);

    this.usersService
      .clearCurrentProfile();

    this.currentProfile = null;
    this.profileLoaded = false;
    this.menu = [];

    this.profileOpen = false;
    this.isNotificationsOpen = false;

    this.collapsed = false;
    this.hoverExpanded = false;
    this.openGroups.clear();

    void this.router.navigateByUrl(
      '/login',
      {
        replaceUrl: true
      }
    );
  }

  toggleNotifications(event?: MouseEvent): void {
    event?.stopPropagation();
    this.isNotificationsOpen = !this.isNotificationsOpen;
  }

  closeNotifications(): void {
    this.isNotificationsOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (!target.closest('#profileDropdown')) {
      this.profileOpen = false;
    }

    if (this.isNotificationsOpen) {
      const clickedInsideNotif = this.notifWrap?.nativeElement?.contains(target);

      if (!clickedInsideNotif) {
        this.closeNotifications();
      }
    }
  }

  @HostListener('document:keydown.escape')
  onEsc(): void {
    this.profileOpen = false;
    this.closeNotifications();
  }

  enableShell(): void {
    this.user = true;
    this.isLoginRoute = false;
    this.router.navigateByUrl('/dashboard');
  }

  disableShell(): void {
    this.user = false;
    this.isLoginRoute = true;
    this.router.navigateByUrl('/login');
  }

  isFullscreen = false;

  toggleFullscreen(): void {
    const el = document.documentElement;

    if (!document.fullscreenElement) {
      el.requestFullscreen()
        .then(() => this.isFullscreen = true)
        .catch(() => { });
    } else {
      document.exitFullscreen()
        .then(() => this.isFullscreen = false)
        .catch(() => { });
    }
  }

  @HostListener('document:fullscreenchange')
  onFullscreenChange(): void {
    this.isFullscreen = !!document.fullscreenElement;
  }

  isDarkMode = false;

  ngOnInit(): void {
    this.currentUrl =
      this.router.url;

    this.syncShellByUrl(
      this.currentUrl
    );

    const savedTheme =
      sessionStorage.getItem(
        'theme'
      );

    this.applyTheme(
      savedTheme === 'dark'
    );

    this.usersService.currentProfile$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(profile => {
        this.currentProfile = profile;
      });

    this.menuService.currentMenus$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(menus => {
        this.menu =
          this.menuService
            .toNavigationItems(menus);

        if (this.user) {
          this.autoOpenActiveGroup();
          this.updateTitleFromMenu();
        }
      });

    this.tokenDecodeService.claims$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(claims => {
        if (!claims) {
          this.menu = [];
          return;
        }

        if (
          this.tokenDecodeService
            .isAnyPasswordActionRequired()
        ) {
          this.menuService.clearMyMenus();
          return;
        }

        /*
         * Uses the cached menu for this tab when available.
         * Calls the API when the cache has been cleared by
         * login or token refresh.
         */
        this.menuService
          .loadMyMenus(false)
          .subscribe({
            error: error =>
              console.error(
                'Failed to load navigation menus',
                error
              )
          });
      });

    /*
     * Restore the token from sessionStorage
     * after a normal page refresh.
     */
    this.tokenDecodeService.restore();

    /*
     * Starts the 6-hour inactivity watch. Safe to call unconditionally:
     * it only acts (prompts + logs out) while a session is actually
     * authenticated, and any tracked activity keeps resetting the
     * countdown so an active user is never affected by it.
     */
    this.idleTimeout.start();

    if (this.user) {
      this.loadCurrentProfileIfRequired();
    }
  }

  toggleTheme(): void {
    this.applyTheme(!this.isDarkMode);
  }

  private applyTheme(
    isDark: boolean
  ): void {
    this.isDarkMode = isDark;

    const theme =
      isDark
        ? 'dark'
        : 'light';

    document.documentElement
      .setAttribute(
        'data-theme',
        theme
      );

    sessionStorage.setItem(
      'theme',
      theme
    );
  }

  get headerProfileName(): string {
    return (
      this.currentProfile?.name ||
      APP_TEXT.DEFAULT_USER_LABEL
    );
  }

  get headerProfileRole(): string {
    const roles =
      this.currentProfile?.roleNames ||
      [];

    return roles.length
      ? roles.join(', ')
      : APP_TEXT.DEFAULT_USER_LABEL;
  }

  get headerProfileImage(): string {
    return (
      this.currentProfile
        ?.profileImageUrl ||
      'assets/img/user.png'
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}